/**
 * 智能客服 - 坐席拉黑 / 解除拉黑用户
 */
import { apiPost } from '@/utils/request';

export const blackUserApi = {
  /** 拉黑用户，user_id 为 users.id，原因选填（超过 255 字由后端截断） */
  black: (userId: number, reason?: string) =>
    apiPost<{ user_id: number; is_black: 1; black_at: string }>('/black-user/black', {
      user_id: userId,
      ...(reason ? { reason } : {}),
    }),
  /** 解除拉黑 */
  unblack: (userId: number) =>
    apiPost<{ user_id: number; is_black: 0 }>('/black-user/unblack', { user_id: userId }),
};
